import { gql } from "@apollo/client"

export const NOTIFICATION_TEMPLATE_TYPE_DETAIL_FRAG = gql`
  fragment NotificationTemplateTypeDetailFrag on NotificationTemplateType {
    id
    alias
    body
    title
    body
  }
`

export const NOTIFICATION_FRAG = gql`
  fragment NotificationFrag on NotificationType {
    id
    template {
      id
      name: alias
    }
    users {
      id
      fullName
      number
    }
    messegeType
    groups: userGroups {
      id
      name
    }
  }
`

export const NOTIFICATION_V1_FRAG = gql`
  fragment NotificationTemplateDetailV1Frag on NewNotificationTemplateType {
    id
    body
    codename
    isActive
    title
    name
    title
    provider {
      id
      name
      codename
      kind
    }
    isProgrammatic
    providerVariables
    dataVariables
    extraFields
    dataSource {
      id
      inputs
      name
      outputs
      isActive
      codename
    }
  }
`

export const USER_QUERY_FRAG = gql`
  fragment UserQueryFrag on UserQueryType {
    id
    name
    codename
    filters {
      id
      alias: displayName
      referenceQuery
      fieldType
      value
      isRangeValue
      exclude
    }
  }
`
